export default "__VITE_ASSET__fbT9obIe__"